module.exports = __webpack_public_path__ + "img/logo-m2n.7a77823d.svg";